<span *ngIf="document">{{document.original_filename}}</span>
<mat-icon>cloud_download</mat-icon>
<mat-icon>delete</mat-icon>
